var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwinkle112(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "286.28996765607843 512.2081533261958 19.164792511549592 18.823328009917304",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M290.29,521.77c.02-3,2.52-5.47,5.63-5.56,3.11-.08,5.66,2.45,5.53,5.5-.13,2.97-2.79,5.39-5.86,5.32-3-.07-5.31-2.37-5.3-5.27Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinkle112);
export default __webpack_public_path__ + "static/media/twinkle-1-12.09cb26efb8704ba795ae9e08d6f197fd.svg";
export { ForwardRef as ReactComponent };